import axios from "axios";
import rs_wechat from "@/config/rs_wechat";
import { useAppStore } from "@/stores/app";
import { getCurrentEnv, SUPPORT_ENV } from "@/utils/util";

let config: any  = 'dev';
const env: any = getCurrentEnv();

if (env === SUPPORT_ENV.prod) {
  config = rs_wechat.prod;
} else if (env === SUPPORT_ENV.qa) {
  config = rs_wechat.qa;
} else {
  config = rs_wechat.dev;
}
export default class Authentication {
  get openID(): string {
    const openID = localStorage.getItem("openID") || "";
    return openID;
  }

  public async lambdaAuthorize(
    accessToken: string,
    idTokenClaims: string,
    type: string
  ): Promise<LoginSuccess> {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
      "x-id-token": idTokenClaims
    };
    const response = await axios({
      url: `${config.base_url}/login`,
      method: "POST",
      headers,
      data: {
        openID: this.openID,
        type
      }
    });

    const authData = response.data as LoginSuccess;
    this.setAuthentication(authData);
    return authData;
  }

  public async logout(openID: string, accessToken: string): Promise<void> {
    const data = { type: "logout", openID };
    await axios({
      url: `${config.base_url}/login`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`
      },
      data
    });

    localStorage.removeItem("authentication");
  }

  public async getOpenID(
    code: string,
    accessToken: string
  ): Promise<string | void> {
    try {
      const app = useAppStore();
      app.setIsloading(true);
      const snsapi_base_response = await axios({
        url: `${config.base_url}/login`,
        method: "POST",
        data: {
          code,
          type: "oauth2"
        },
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      let openid;
      const response = snsapi_base_response.data;
      try {
        openid = JSON.parse(response).openid;
      } catch (error) {
        openid = response.openid;
      }
      app.setIsloading(false);
      return openid;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async checkLoggedIn(
    openID: string,
    accessToken: string
  ): Promise<boolean | void> {
    try {
      const app = useAppStore();
      app.setIsloading(true);
      const checkAuthResponse = await axios({
        url: `${config.base_url}/login`,
        method: "POST",
        data: {
          openID,
          type: "check-login"
        },
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });
      const { isLoggedIn } = checkAuthResponse.data as CheckAuthResponse;
      app.setIsloading(false);
      return isLoggedIn;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  private setAuthentication(data: LoginSuccess) {
    localStorage.setItem("authentication", JSON.stringify(data));
  }

  public setOpenID(openID: string): void {
    localStorage.setItem("openID", openID);
  }
}